import { render, staticRenderFns } from "./AddMentor.vue?vue&type=template&id=727807b4&scoped=true"
import script from "./AddMentor.vue?vue&type=script&lang=js"
export * from "./AddMentor.vue?vue&type=script&lang=js"
import style0 from "./AddMentor.vue?vue&type=style&index=0&id=727807b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727807b4",
  null
  
)

export default component.exports